<template lang="pug">
header 
  span.title-icon
      i.tit-icon(v-bind:class="[icon]" aria-hidden="true")
  | {{title}}
  slot
</template>
<script>
  export default {
    props: {
      icon: String,
      title: String
    }
  }
</script>
<style scoped>
.tit-icon {
  display: block;
}
.iframe-header{
  background-color: #fff;
  border-bottom: 1px solid rgb(227, 227, 227);
  padding: 5px 15px;

  header{
    height: 28px;
    margin: 10px 0;
    line-height: 28px;
    display: inline-block;
    font-weight: 700;
    font-size: 16px;
    padding-left: 0;
    .tip {
        color: #999;
        font-size: 12px;
        margin-left: 5px;
        display: inline-block;
        vertical-align: middle;
    }
  }

  .title-icon{
    height: 28px;
    width: 28px;
    border-radius: 50%;
    background-color: #66718d;
    text-align: center;
    margin: 0 5px 0 0;
    display: inline-block;
    font-weight: normal;
    font-size: 12px;

    .tit-icon{
      color: #fff;
      line-height: 28px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// tableTitle.vue?69cf6552